import api from './api';

export const vpnService = {
  // Pobierz wszystkie połączenia VPN
  getConnections: async () => {
    const response = await api.get('/vpn/connections');
    return response.data;
  },

  // Pobierz połączenie VPN po ID
  getConnection: async (id) => {
    const response = await api.get(`/vpn/connections/${id}`);
    return response.data;
  },

  // Dodaj nowe połączenie VPN
  addConnection: async (connectionData) => {
    const response = await api.post('/vpn/connections', connectionData);
    return response.data;
  },

  // Aktualizuj połączenie VPN
  updateConnection: async (id, connectionData) => {
    const response = await api.put(`/vpn/connections/${id}`, connectionData);
    return response.data;
  },

  // Usuń połączenie VPN
  deleteConnection: async (id) => {
    const response = await api.delete(`/vpn/connections/${id}`);
    return response.data;
  },

  // Połącz z VPN
  connect: async (id) => {
    const response = await api.post(`/vpn/connections/${id}/connect`);
    return response.data;
  },

  // Rozłącz z VPN
  disconnect: async (id) => {
    const response = await api.post(`/vpn/connections/${id}/disconnect`);
    return response.data;
  },

  // Pobierz status wszystkich połączeń VPN
  getStatus: async () => {
    const response = await api.get('/vpn/status');
    return response.data;
  },

  // Testuj połączenie VPN z konkretnym adresem
  testConnection: async (targetIP, port = null) => {
    const response = await api.post('/vpn/test-connection', { targetIP, port });
    return response.data;
  }
};
